import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import ListingSection from '../Component/MediaRoomPage/ListingSection'
import { useAuth } from '../Context/ContextProvider'
import { useLocation } from 'react-router-dom'
function MediaRoomPage() {
    const [latestStory, setLatestStory] = useState([])
    const {getMediaRoom,parseQueryParams} = useAuth()
    const [pagination, setPagination] = useState(null)
    const location = useLocation()
    useEffect(() => {
        const fetchLatestStory = async () => {
            try {
                const parsed = parseQueryParams(location.search);
                const result = await getMediaRoom(parsed)
                setLatestStory(result?.data?.storiesList)
                setPagination(result?.data?.pagination)
            } catch (error) {
                console.error("An error occurred while fetching data:", error);
            }
        }
        fetchLatestStory()
    }, [location.search])

  return (
    <div>
        <NavBar/>
        <ListingSection  latestStory={latestStory} pagination={pagination}/>
        <Footer/>
    </div>
  )
}

export default MediaRoomPage